var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"phone",attrs:{"src":require("../assets/phone.png")},on:{"click":_vm.onCall}})
}
var staticRenderFns = []

export { render, staticRenderFns }